// extracted by mini-css-extract-plugin
module.exports = {"block":"block--aErAg","block_selected":"block_selected--3fQdI","name":"name--2Y__f","tag":"tag--wibDx","date":"date--3X3XS"};
    if(module.hot) {
      // 1637785525808
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  